export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/ob-step-10.png?9db3e4ecb6562148d7b43618a8e64f42";